// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.common-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.common-modal-content {
  background: white;
  z-index: 10000;
  padding: 2rem;
  border-radius: 10px;
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
  max-width: 800px;
}

.common-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.4);
}

.close-cross {
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.client-common-modal-footer {
  margin-top: 1rem;
  text-align: right;
}

.invoice-export-modal {
  padding: 1rem 1.5rem;
}
.invoice-export-modal h3 {
  font-size: 1.6rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.3rem;
  text-align: center;
}
.invoice-export-modal .export-subtext {
  font-size: 0.95rem;
  color: #6b7280;
  text-align: center;
  margin-bottom: 1.5rem;
}
.invoice-export-modal .export-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1rem;
}
.invoice-export-modal .export-options .export-option-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 18px;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 500;
  color: #1f2937;
  background-color: #f3f4f6;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.25s ease;
}
.invoice-export-modal .export-options .export-option-btn .export-icon {
  font-size: 1.1rem;
}
.invoice-export-modal .export-options .export-option-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
.invoice-export-modal .export-options .export-option-btn:active {
  transform: scale(0.98);
}
.invoice-export-modal .export-options .export-option-btn.pending {
  background-color: #fef9c3;
  color: #92400e;
  border: 1px solid #fde68a;
}
.invoice-export-modal .export-options .export-option-btn.paid {
  background-color: #d1fae5;
  color: #065f46;
  border: 1px solid #6ee7b7;
}
.invoice-export-modal .export-options .export-option-btn.part-payment {
  background-color: #dbeafe;
  color: #1e40af;
  border: 1px solid #93c5fd;
}
.invoice-export-modal .export-options .export-option-btn.all {
  background-color: #e5e7eb;
  color: #374151;
  border: 1px solid #d1d5db;
}

.exp-service-modal-body h3 {
  font-size: 1.2rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
}
.exp-service-modal-body .new-service-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  margin-bottom: 1rem;
  box-sizing: border-box;
}
.exp-service-modal-body .new-service-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.exp-service-modal-body .submit-btn-common-modal {
  width: 100%;
  padding: 0.8rem;
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 14px rgba(59, 130, 246, 0.3);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.exp-service-modal-body .submit-btn-common-modal:hover {
  box-shadow: 0 8px 25px rgba(59, 130, 246, 0.4);
  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
}
.exp-service-modal-body .submit-btn-common-modal:hover::before {
  left: 100%;
}
.exp-service-modal-body .submit-btn-common-modal:active {
  transform: translateY(0);
  box-shadow: 0 4px 14px rgba(59, 130, 246, 0.3);
}
.exp-service-modal-body .submit-btn-common-modal:disabled {
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 8px rgba(156, 163, 175, 0.2);
}
.exp-service-modal-body .submit-btn-common-modal:disabled::before {
  display: none;
}
.exp-service-modal-body .submit-btn-common-modal:disabled:hover {
  transform: none;
  box-shadow: 0 2px 8px rgba(156, 163, 175, 0.2);
}
.exp-service-modal-body .submit-btn-common-modal.loading {
  position: relative;
  color: transparent;
}
.exp-service-modal-body .submit-btn-common-modal.loading::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  margin: -10px 0 0 -10px;
  border: 2px solid #ffffff;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.client-modal-header .close-cross {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
}
.client-modal-header .close-cross:hover {
  color: #374151;
  background-color: #f3f4f6;
}

@media (max-width: 768px) {
  .exp-service-modal-body {
    padding: 2rem 1.5rem 1.5rem;
  }
  .exp-service-modal-body h3 {
    font-size: 1.5rem;
    margin-bottom: 0.75rem;
  }
  .exp-service-modal-body::before {
    font-size: 0.8rem;
    margin-bottom: 1.25rem;
  }
  .exp-service-modal-body .new-service-input {
    padding: 0.875rem 1rem;
    margin-bottom: 1.5rem;
    font-size: 0.95rem;
  }
  .exp-service-modal-body .submit-btn-common-modal {
    padding: 0.875rem 1.25rem;
    font-size: 0.95rem;
  }
}
@media (max-width: 480px) {
  .exp-service-modal-body {
    padding: 1.5rem 1rem 1rem;
  }
  .exp-service-modal-body h3 {
    font-size: 1.25rem;
    padding-right: 1.5rem;
  }
  .exp-service-modal-body::before {
    font-size: 0.75rem;
    margin-bottom: 1rem;
  }
}
@keyframes slideInScale {
  0% {
    opacity: 0;
    transform: translateY(-20px) scale(0.9);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.exp-service-modal-body .new-service-input:focus-visible,
.exp-service-modal-body .submit-btn-common-modal:focus-visible {
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/components/CommonModal/CommonModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EAEA,gBAAA;AAAF;;AAGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,8BAAA;AAAF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AACF;;AACA;EACE,gBAAA;EACA,iBAAA;AAEF;;AAAA;EACE,oBAAA;AAGF;AADE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;AAGJ;AAAE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AAEJ;AACA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,6BAAA;EACA,eAAA;EACA,0BAAA;AACJ;AACI;EACE,iBAAA;AACN;AAEI;EACE,2BAAA;EACA,yCAAA;AAAN;AAGI;EACE,sBAAA;AADN;AAII;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAFN;AAKI;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAHN;AAMI;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAJN;AAOI;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AALN;;AAsBE;EAYE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA9BJ;AA4CE;EA4BE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AArEJ;AAuEI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AArEN;AAyEE;EACE,WAAA;EACA,eAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;EACA,yBAAA;EACA,qBAAA;AAvEJ;AA0FI;EAEE,8CAAA;EACA,6DAAA;AAzFN;AA2FM;EACE,UAAA;AAzFR;AA6FI;EACE,wBAAA;EACA,8CAAA;AA3FN;AA8FI;EACE,6DAAA;EACA,mBAAA;EACA,eAAA;EACA,8CAAA;AA5FN;AA8FM;EACE,aAAA;AA5FR;AA+FM;EACE,eAAA;EACA,8CAAA;AA7FR;AAkGI;EACE,kBAAA;EACA,kBAAA;AAhGN;AAkGM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,yBAAA;EACA,iCAAA;EACA,kBAAA;EACA,kCAAA;AAhGR;;AAuGA;EAyBE,gBAAA;EACE,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AA5HJ;AA8HI;EACE,cAAA;EACA,yBAAA;AA5HN;;AAsIA;EACE;IACE,2BAAA;EAnIF;EAqIE;IACE,iBAAA;IACA,sBAAA;EAnIJ;EAsIE;IACE,iBAAA;IACA,sBAAA;EApIJ;EAuIE;IACE,sBAAA;IACA,qBAAA;IACA,kBAAA;EArIJ;EAwIE;IACE,yBAAA;IACA,kBAAA;EAtIJ;AACF;AA0IA;EACE;IACE,yBAAA;EAxIF;EA0IE;IACE,kBAAA;IACA,qBAAA;EAxIJ;EA2IE;IACE,kBAAA;IACA,mBAAA;EAzIJ;AACF;AA8IA;EACE;IACE,UAAA;IACA,uCAAA;EA5IF;EA8IA;IACE,UAAA;IACA,iCAAA;EA5IF;AACF;AA+IA;EACE;IACE,uBAAA;EA7IF;EA+IA;IACE,yBAAA;EA7IF;AACF;AAkJE;;EAGE,mBAAA;AAjJJ","sourcesContent":[".common-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 9999;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.common-modal-content {\r\n  background: white;\r\n  z-index: 10000;\r\n  padding: 2rem;\r\n  border-radius: 10px;\r\n  position: relative;\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n  // width: 90%;\r\n  max-width: 800px;\r\n}\r\n\r\n.common-modal-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  height: 100%;\r\n  width: 100%;\r\n  background: rgba(0,0,0,0.4);\r\n}\r\n.close-cross {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 15px;\r\n  background: none;\r\n  border: none;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n}\r\n.client-common-modal-footer {\r\n  margin-top: 1rem;\r\n  text-align: right;\r\n}\r\n.invoice-export-modal {\r\n  padding: 1rem 1.5rem;\r\n\r\n  h3 {\r\n    font-size: 1.6rem;\r\n    font-weight: 600;\r\n    color: #1f2937;\r\n    margin-bottom: 0.3rem;\r\n    text-align: center;\r\n  }\r\n\r\n  .export-subtext {\r\n    font-size: 0.95rem;\r\n    color: #6b7280;\r\n    text-align: center;\r\n    margin-bottom: 1.5rem;\r\n  }\r\n\r\n.export-options {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\r\n  gap: 1rem;\r\n\r\n  .export-option-btn {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 8px;\r\n    padding: 12px 18px;\r\n    border-radius: 10px;\r\n    font-size: 0.95rem;\r\n    font-weight: 500;\r\n    color: #1f2937;\r\n    background-color: #f3f4f6;\r\n    border: 1px solid transparent;\r\n    cursor: pointer;\r\n    transition: all 0.25s ease;\r\n\r\n    .export-icon {\r\n      font-size: 1.1rem;\r\n    }\r\n\r\n    &:hover {\r\n      transform: translateY(-1px);\r\n      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\r\n    }\r\n\r\n    &:active {\r\n      transform: scale(0.98);\r\n    }\r\n\r\n    &.pending {\r\n      background-color: #fef9c3;\r\n      color: #92400e;\r\n      border: 1px solid #fde68a;\r\n    }\r\n\r\n    &.paid {\r\n      background-color: #d1fae5;\r\n      color: #065f46;\r\n      border: 1px solid #6ee7b7;\r\n    }\r\n\r\n    &.part-payment {\r\n      background-color: #dbeafe;\r\n      color: #1e40af;\r\n      border: 1px solid #93c5fd;\r\n    }\r\n\r\n    &.all {\r\n      background-color: #e5e7eb;\r\n      color: #374151;\r\n      border: 1px solid #d1d5db;\r\n    }\r\n  }\r\n}\r\n\r\n}\r\n\r\n\r\n// Service Modal SCSS - Modern styling for expense form modals\r\n\r\n.exp-service-modal-body {\r\n  // padding: 1.5rem;\r\n  // // background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);\r\n  // background-color: #f8fafc;\r\n  // border-radius: 16px;\r\n  // position: relative;\r\n  \r\n  h3 {\r\n    // font-size: 1.5rem;\r\n    // font-weight: 700;\r\n    // color: #1f2937;\r\n    // margin-bottom: 1rem;\r\n    // text-align: center;\r\n    // // padding-right: 2rem;\r\n    // background: linear-gradient(135deg, #3b82f6, #1d4ed8);\r\n    // -webkit-background-clip: text;\r\n    // -webkit-text-fill-color: transparent;\r\n    // background-clip: text;\r\n    // letter-spacing: -0.025em;\r\n    font-size: 1.2rem;\r\n    font-weight: 500;\r\n    color: #374151;\r\n    margin: 0 0 1rem 0;\r\n  }\r\n\r\n  // Subtitle for better UX\r\n  // &::before {\r\n  //   content: \"Enter the new field name below\";\r\n  //   display: block;\r\n  //   font-size: 0.875rem;\r\n  //   color: #6b7280;\r\n  //   text-align: center;\r\n  //   margin-bottom: 1.5rem;\r\n  //   font-style: italic;\r\n  // }\r\n\r\n  .new-service-input {\r\n    // width: 100%;\r\n    // padding: 1rem 1.25rem;\r\n    // border: 2px solid #e5e7eb;\r\n    // border-radius: 12px;\r\n    // font-size: 1rem;\r\n    // color: #374151;\r\n    // background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);\r\n    // transition: all 0.3s ease;\r\n    // margin-bottom: 2rem;\r\n    // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n    \r\n    // &:focus {\r\n    //   outline: none;\r\n    //   // border: none;\r\n    //   background: #ffffff;\r\n    //   transform: translateY(-1px);\r\n    // }\r\n\r\n    // &::placeholder {\r\n    //   color: #9ca3af;\r\n    //   // font-style: italic;\r\n    // }\r\n\r\n    // &:hover {\r\n    //   border-color: #d1d5db;\r\n    //   // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n    // }\r\n    width: 100%;\r\n    padding: 0.5rem;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 0.25rem;\r\n    font-size: 0.875rem;\r\n    margin-bottom: 1rem;\r\n    box-sizing: border-box;\r\n\r\n    &:focus {\r\n      outline: none;\r\n      border-color: #3b82f6;\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n    }\r\n  }\r\n\r\n  .submit-btn-common-modal {\r\n    width: 100%;\r\n    padding: 0.8rem;\r\n    background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 12px;\r\n    font-size: 0.9rem;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    position: relative;\r\n    overflow: hidden;\r\n    box-shadow: 0 4px 14px rgba(59, 130, 246, 0.3);\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5px;\r\n\r\n    // Shine effect\r\n    // &::before {\r\n    //   content: '';\r\n    //   position: absolute;\r\n    //   top: 0;\r\n    //   left: -100%;\r\n    //   width: 100%;\r\n    //   height: 100%;\r\n    //   background: linear-gradient(\r\n    //     90deg, \r\n    //     transparent, \r\n    //     rgba(255, 255, 255, 0.3), \r\n    //     transparent\r\n    //   );\r\n    //   transition: left 0.6s ease;\r\n    // }\r\n\r\n    &:hover {\r\n      // transform: translateY(-2px);\r\n      box-shadow: 0 8px 25px rgba(59, 130, 246, 0.4);\r\n      background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);\r\n      \r\n      &::before {\r\n        left: 100%;\r\n      }\r\n    }\r\n\r\n    &:active {\r\n      transform: translateY(0);\r\n      box-shadow: 0 4px 14px rgba(59, 130, 246, 0.3);\r\n    }\r\n\r\n    &:disabled {\r\n      background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);\r\n      cursor: not-allowed;\r\n      transform: none;\r\n      box-shadow: 0 2px 8px rgba(156, 163, 175, 0.2);\r\n\r\n      &::before {\r\n        display: none;\r\n      }\r\n\r\n      &:hover {\r\n        transform: none;\r\n        box-shadow: 0 2px 8px rgba(156, 163, 175, 0.2);\r\n      }\r\n    }\r\n\r\n    // Loading state\r\n    &.loading {\r\n      position: relative;\r\n      color: transparent;\r\n\r\n      &::after {\r\n        content: '';\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 50%;\r\n        width: 20px;\r\n        height: 20px;\r\n        margin: -10px 0 0 -10px;\r\n        border: 2px solid #ffffff;\r\n        border-top: 2px solid transparent;\r\n        border-radius: 50%;\r\n        animation: spin 1s linear infinite;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Enhanced close button for service modal\r\n.client-modal-header .close-cross {\r\n  // top: 0.3rem;\r\n  // right: 0.3rem;\r\n  // width: 36px;\r\n  // height: 36px;\r\n  // display: flex;\r\n  // align-items: center;\r\n  // justify-content: center;\r\n  // border-radius: 50%;\r\n  // background: rgba(239, 68, 68, 0.1);\r\n  // color: #ef4444;\r\n  // font-size: 18px;\r\n  // font-weight: 600;\r\n  // transition: all 0.2s ease;\r\n  // z-index: 10;\r\n\r\n  // &:hover {\r\n  //   background: rgba(239, 68, 68, 0.2);\r\n  //   transform: scale(1.1) rotate(90deg);\r\n  //   color: #dc2626;\r\n  // }\r\n\r\n  // &:active {\r\n  //   transform: scale(0.95) rotate(90deg);\r\n  // }\r\n  background: none;\r\n    border: none;\r\n    font-size: 1.5rem;\r\n    color: #6b7280;\r\n    cursor: pointer;\r\n    padding: 0;\r\n    width: 2rem;\r\n    height: 2rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 0.25rem;\r\n\r\n    &:hover {\r\n      color: #374151;\r\n      background-color: #f3f4f6;\r\n    }\r\n}\r\n\r\n// Animation for modal entrance\r\n.exp-service-modal-body {\r\n  //animation: slideInScale 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\r\n}\r\n\r\n// Responsive design\r\n@media (max-width: 768px) {\r\n  .exp-service-modal-body {\r\n    padding: 2rem 1.5rem 1.5rem;\r\n    \r\n    h3 {\r\n      font-size: 1.5rem;\r\n      margin-bottom: 0.75rem;\r\n    }\r\n\r\n    &::before {\r\n      font-size: 0.8rem;\r\n      margin-bottom: 1.25rem;\r\n    }\r\n\r\n    .new-service-input {\r\n      padding: 0.875rem 1rem;\r\n      margin-bottom: 1.5rem;\r\n      font-size: 0.95rem;\r\n    }\r\n\r\n    .submit-btn-common-modal {\r\n      padding: 0.875rem 1.25rem;\r\n      font-size: 0.95rem;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .exp-service-modal-body {\r\n    padding: 1.5rem 1rem 1rem;\r\n    \r\n    h3 {\r\n      font-size: 1.25rem;\r\n      padding-right: 1.5rem;\r\n    }\r\n\r\n    &::before {\r\n      font-size: 0.75rem;\r\n      margin-bottom: 1rem;\r\n    }\r\n  }\r\n}\r\n\r\n// Keyframe animations\r\n@keyframes slideInScale {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateY(-20px) scale(0.9);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateY(0) scale(1);\r\n  }\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n// Focus states for accessibility\r\n.exp-service-modal-body {\r\n  .new-service-input:focus-visible,\r\n  .submit-btn-common-modal:focus-visible {\r\n    // outline: 2px solid #3b82f6;\r\n    outline-offset: 2px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
